import {
    ChangeDetectorRef,
    ElementRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/app.service";

@Component({
    selector: "app-academic-aside",
    templateUrl: "./academic-aside.component.html",
    styleUrls: ["./academic-aside.component.scss"],
})
export class AcademicAsideComponent implements OnInit, OnDestroy {
    selectedItem: string = "";
    items = [
        { Name: "Academic Regulation", Url: "academic-rules" },
        { Name: "Academic Calender", Url: "academic-calendar" },
        { Name: "Our Curriculam", Url: "our-curriculum" },
    ];
    imageLoaded = false;
    fetchinData = true;
    ImageAlbums: any;
    GBs: any;
    GBs1: any;
    GBs2: any;
    TeacherInfo: any;
    GBms: any;
    GBms1: any;
    selectedItemName = "";
    showFullContent = false;
    showFullOverview = false;
    showFullWhy = false;
    showFullIns = false;
    showFullBuilding = false;
    showFullCulture = false;
    private ngUnsubscribe = new Subject();

    aca_rules: any;
    curriculams: any;
    academic_calender_data: any;
    rules_and_regulation_data: any;
    acdemic: any;
    acdemic_data: any;
    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}
    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const item = params.get("item");
            const matchedItem = this.items.find((i) => i.Url === item);
            if (item && matchedItem && item == matchedItem.Url) {
                this.selectedItem = item;
                this.selectedItemName = matchedItem.Name;
            } else {
                this.selectedItem = this.items[0].Url;
                this.selectedItemName = this.items[0].Name;
                this.location.replaceState(`/${this.selectedItem}`);
            }
            this.FetchData();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
    FetchData() {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        if (
            this.selectedItem === "our-curriculum" ||
            this.selectedItem === "rules-and-regulations" ||
            this.selectedItem == "academic-calendar" ||
            this.selectedItem == "academic-rules"
        ) {
            this.About_data();
        }
    }

    About_data() {
        forkJoin([this.appService.getContents()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "All Response For About Us");

                this.acdemic_data = response[0].data;

                if (this.acdemic_data != null) {
                    // Academic Rules
                    let academic_rules = this.acdemic_data.filter(
                        (x) => x.ContentCategoryName == "Academic Regulation"
                    );
                    this.aca_rules = academic_rules[0];
                    console.log(this.aca_rules, "Academic Regulation");
                    // Our Currriculam
                    let our_curriculam = this.acdemic_data.filter(
                        (x) => x.ContentCategoryName == "Our Curriculum"
                    );
                    this.curriculams = our_curriculam[0];
                    console.log(this.curriculams, "Our Curriculams Data");
                    // Acdemic Calender
                    let academic_calender = this.acdemic_data.filter(
                        (x) => x.ContentCategoryName == "Academic Calendar "
                    );
                    this.academic_calender_data = academic_calender;
                    console.log(
                        this.academic_calender_data,
                        "Academic Calender"
                    );
                    // Rules and Regulation
                    let rules_and_regulation = this.acdemic_data.filter(
                        (x) => x.ContentCategoryName == "Rules and Regulations"
                    );
                    this.rules_and_regulation_data = rules_and_regulation[0];
                    console.log(
                        this.rules_and_regulation_data,
                        "Rules and Regulation Data"
                    );
                }

                this.fetchinData = false;
            });
    }
    selectItem(item: string) {
        this.selectedItem = item;
        const matchedItem = this.items.find((i) => i.Url === item);
        this.selectedItemName = matchedItem.Name;
        if (this.selectedItem === "our-curriculum") {
            this.location.go(`/academic/${item}`);
        } else if (this.selectedItem === "rules-and-regulations") {
            this.location.go(`/academic/${item}`);
        } else if (this.selectedItem === "academic-rules") {
            this.location.go(`/academic/${item}`);
        } else if (this.selectedItem === "academic-calendar") {
            this.location.go(`/academic/${item}`);
        } else {
            this.location.go(`/academic/academic-rules`);
        }
    }
    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }
}
